
// | Wraps Javascript's `RegExp` object that enables matching strings with
// | patterns defined by regular expressions.
// | For details of the underlying implementation, see [RegExp Reference at MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp).
"use strict";
var $foreign = require("./foreign.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_String_CodeUnits = require("../Data.String.CodeUnits/index.js");
var Data_String_Regex_Flags = require("../Data.String.Regex.Flags/index.js");
var showRegex = new Data_Show.Show($foreign.showRegexImpl);

// | Returns `Just` the index of the first match of the `Regex` in the string,
// | or `Nothing` if there is no match.
var search = $foreign["_search"](Data_Maybe.Just.create)(Data_Maybe.Nothing.value);

// | Transforms occurrences of the `Regex` using a function of the matched
// | substring and a list of captured substrings of type `Maybe String`,
// | where `Nothing` represents an unmatched optional capturing group.
// | See the [reference](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace#Specifying_a_function_as_a_parameter).
var replace$prime = $foreign["_replaceBy"](Data_Maybe.Just.create)(Data_Maybe.Nothing.value);

// | Returns the string representation of the given `RegexFlags`.
var renderFlags = function (v) {
    return (function () {
        if (v.value0.global) {
            return "g";
        };
        return "";
    })() + ((function () {
        if (v.value0.ignoreCase) {
            return "i";
        };
        return "";
    })() + ((function () {
        if (v.value0.multiline) {
            return "m";
        };
        return "";
    })() + ((function () {
        if (v.value0.dotAll) {
            return "s";
        };
        return "";
    })() + ((function () {
        if (v.value0.sticky) {
            return "y";
        };
        return "";
    })() + (function () {
        if (v.value0.unicode) {
            return "u";
        };
        return "";
    })()))));
};

// | Constructs a `Regex` from a pattern string and flags. Fails with
// | `Left error` if the pattern contains a syntax error.
var regex = function (s) {
    return function (f) {
        return $foreign.regexImpl(Data_Either.Left.create)(Data_Either.Right.create)(s)(renderFlags(f));
    };
};

// | Parses the string representation of `RegexFlags`.
var parseFlags = function (s) {
    return new Data_String_Regex_Flags.RegexFlags({
        global: Data_String_CodeUnits.contains("g")(s),
        ignoreCase: Data_String_CodeUnits.contains("i")(s),
        multiline: Data_String_CodeUnits.contains("m")(s),
        dotAll: Data_String_CodeUnits.contains("s")(s),
        sticky: Data_String_CodeUnits.contains("y")(s),
        unicode: Data_String_CodeUnits.contains("u")(s)
    });
};

// | Matches the string against the `Regex` and returns an array of matches
// | if there were any. Each match has type `Maybe String`, where `Nothing`
// | represents an unmatched optional capturing group.
// | See [reference](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/match).
var match = $foreign["_match"](Data_Maybe.Just.create)(Data_Maybe.Nothing.value);

// | Returns the `RegexFlags` used to construct the given `Regex`.
var flags = function ($9) {
    return Data_String_Regex_Flags.RegexFlags.create($foreign.flagsImpl($9));
};
module.exports = {
    regex: regex,
    flags: flags,
    renderFlags: renderFlags,
    parseFlags: parseFlags,
    match: match,
    "replace'": replace$prime,
    search: search,
    showRegex: showRegex,
    source: $foreign.source,
    test: $foreign.test,
    replace: $foreign.replace,
    split: $foreign.split
};
